import { useState, useEffect, useCallback } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router'
import { Building2, List, LogOut, User } from 'lucide-react'
import { useAuth } from '../../contexts/useAuth'
import { Sidebar } from './Sidebar'
import { Dropdown, DropdownItem, Tooltip } from '../ui'

export function AdminLayout() {
  const { user, logout } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  // Desktop: sidebar collassata (icone senza testo), stessa preferenza di MainLayout
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => localStorage.getItem('sidebar-collapsed') === 'true'
  )

  // Mobile/Tablet (<992px): sidebar aperta/chiusa come overlay, come in MainLayout
  const [mobileOpen, setMobileOpen] = useState(false)

  const isMobile = useCallback(() => window.innerWidth < 992, [])

  useEffect(() => {
    localStorage.setItem('sidebar-collapsed', String(sidebarCollapsed))
    if (sidebarCollapsed) {
      document.documentElement.classList.add('sidebar-will-collapse')
    } else {
      document.documentElement.classList.remove('sidebar-will-collapse')
    }
  }, [sidebarCollapsed])

  useEffect(() => {
    setMobileOpen(false)
  }, [location.pathname])

  const toggleSidebar = useCallback(() => {
    if (isMobile()) {
      setMobileOpen((prev) => !prev)
    } else {
      setSidebarCollapsed((prev) => !prev)
    }
  }, [isMobile])

  return (
    <>
      <div
        className={`sidebar-overlay${mobileOpen ? ' show' : ''}`}
        id="sidebarOverlay"
        onClick={() => setMobileOpen(false)}
      ></div>

      <Sidebar variant="admin" collapsed={sidebarCollapsed} mobileOpen={mobileOpen} onToggle={toggleSidebar} />

      <div className="main-wrapper" id="mainWrapper">
        <header className="top-navbar" id="topNavbar">
          <div className="top-navbar-left">
            <Tooltip content="Toggle Menu" position="bottom">
              <button
                className="top-navbar-toggle"
                type="button"
                onClick={toggleSidebar}
                aria-label="Toggle Menu"
              >
                <List size={20} />
              </button>
            </Tooltip>
            <span className="top-navbar-title ml-3 font-semibold">Pannello Super Admin</span>
          </div>
          <div className="top-navbar-right">
            <Dropdown
              trigger={
                <button className="top-navbar-user" type="button">
                  <div className="top-navbar-avatar">
                    {user?.avatarUrl
                      ? <img src={user.avatarUrl} alt="" className="h-full w-full rounded-full object-cover" />
                      : <User size={16} />}
                  </div>
                  <div className="top-navbar-user-info hidden! md:flex!">
                    <span className="top-navbar-user-name">{user?.email}</span>
                    <span className="top-navbar-user-role">Admin</span>
                  </div>
                </button>
              }
            >
              <DropdownItem onClick={() => navigate('/admin/agencies')}>
                <span className="flex items-center gap-2">
                  <Building2 size={15} /> Agenzie
                </span>
              </DropdownItem>
              <div className="my-1 border-t border-border-subtle" />
              <DropdownItem onClick={() => logout()}>
                <span className="flex items-center gap-2 text-negative">
                  <LogOut size={15} /> Logout
                </span>
              </DropdownItem>
            </Dropdown>
          </div>
        </header>

        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </>
  )
}
